/* eslint-disable react/jsx-pascal-case */
import { Routes, Route } from "react-router";
import { Login as NewLogin } from "../features/auth/presentation/pages/Login";
import { ConfigureLogin as NewConfigureLogin } from "../features/auth/presentation/pages/Configure_login"; //
import { GrupoAcessoLista } from "../features/administracao/presentation/pages/GruposAcesso_lista";
import { GruposAcessoCadastro } from "../features/administracao/presentation/pages/GruposAcesso_cadastro";
import { FuncionariosLista } from "../features/rh/presentation/pages/Funcionarios_lista";
import { FuncionariosCadastro } from "../features/rh/presentation/pages/Funcionarios_cadastro";
import { MotivoDemissaoLista } from "../features/rh/presentation/pages/MotivoDemissao_lista";
import { CadastroAssinaturaLista } from "../features/rh/presentation/pages/CadastroAssinaturas_lista";
import { MotivoAfastamentoLista } from "../features/rh/presentation/pages/MotivoAfastamento_lista";
import { CargosLista } from "../features/rh/presentation/pages/Cargos_lista";
import { CargosCadastro } from "../features/rh/presentation/pages/Cargos_cadastro";
import { TreinamentosLista } from "../features/rh/presentation/pages/Treinamentos_lista";
import { TreinamentoCargoCadastro } from "../features/rh/presentation/pages/TreinamentoCargo_cadastro";
import { HabilidadesLista } from "../features/rh/presentation/pages/Habilidades_lista";
import { HabilidadeCargoCadastro } from "../features/rh/presentation/pages/HabilidadeCargo_cadastro";
import { GestaoTreinamentosLista } from "../features/rh/presentation/pages/GestaoTreinamentos_lista";
import { GestaoTreinamentosCadastro } from "../features/rh/presentation/pages/GestaoTreinamentos_cadastro";
import { AvaliacaoTreinamentoLoteCadastro } from "../features/rh/presentation/pages/AvaliacaoTreinamentoLote_cadastro";
import { TreinamentoFuncionarioCadastro } from "../features/rh/presentation/pages/TreinamentoFuncionario_cadastro";
import { FolhaPagamentoLista } from "../features/rh/presentation/pages/FolhaPagamento_lista";
import { FolhaPagamentoCadastro } from "../features/rh/presentation/pages/FolhaPagamento_cadastro";
import { FolhaPagamentoItensVerba } from "../features/rh/presentation/pages/FolhaPagamento_itensverba";
import { VerbaPagamentoLista } from "../features/rh/presentation/pages/VerbaPagamento_lista";
import { GedRh } from "../features/rh/presentation/pages/GED_rh";
import { ObrasLista } from "../features/obras/presentation/pages/Obras_lista";
import { ObrasInformacoesGerais } from "../features/obras/presentation/pages/Obras_informacoesgerais";
import { ObrasGestaoServicos } from "../features/obras/presentation/pages/Obras_gestao_servicos";
import { EquipamentoMedicao_lista } from "../features/equipamentoMedicoes/presentation/pages/EquipamentoMedicao_lista";
import { CentroCusto_cadastro } from "../features/comercial/presentation/pages/CentroCusto_cadastro";
import { CentroCustoLista } from "../features/comercial/presentation/pages/CentroCusto_lista";
import { ContasReceberLista } from "../features/financeiro/presentation/pages/ContasReceber_lista";
import { ObrasConcretagem } from "../features/obras/presentation/pages/Obras_concretagem";
import { ContasReceberCadastro } from "../features/financeiro/presentation/pages/ContasReceber_cadastro";
import { Obrasmaquinasequipamentos } from "../features/obras/presentation/pages/Obras_maquinasequipamentos";
import { ObrasEquipamentoMedicao } from "../features/obras/presentation/pages/Obras_equipamentosmedicao";
import { ObrasCadastroarea } from "../features/obras/presentation/pages/Obras_cadastroarea";
import { BancoPagamentoLista } from "../features/financeiro/presentation/pages/BancoPagamento_lista";
import { ObrasMateriaisControlados } from "../features/obras/presentation/pages/Obras_materiaiscontrolados";
import { ObrasServicosControlados } from "../features/obras/presentation/pages/Obras_servicoscontrolados";
import { ObraItensChecklistAreaCadastro } from "../features/obras/presentation/pages/ObraItensChecklistArea_cadastro";
import { ObraItensChecklistAreaVerificacao } from "../features/obras/presentation/pages/ObraItensChecklistArea_verificacao";
import { ContasPagarLista } from "../features/financeiro/presentation/pages/ContasPagar_lista";
import { ContasPagarCadastro } from "../features/financeiro/presentation/pages/ContasPagar_cadastro";
import { ObrasTreinamento } from "../features/obras/presentation/pages/Obras_treinamentos";
import { ObrasAlvenariaEstrutural } from "../features/obras/presentation/pages/Obras_alvenariaestrutural";
import { ObrasGestaoResiduos } from "../features/obras/presentation/pages/Obras_gestaoresiduos";
import { Auditores } from "../features/auditoria/presentation/pages/Auditoria_auditores";
import { ControleServicosLista } from "../features/obras/presentation/pages/ControleServicos_lista";
import { ControleMateriaisLista } from "../features/obras/presentation/pages/ControleMateriais_lista";
import { ContasPagarDeletadas } from "../features/financeiro/presentation/pages/ContasPagar_deletadas";
import { ContasReceberDeletadas } from "../features/financeiro/presentation/pages/ContasReceber_deletadas";
import { SaldoBancarioLista } from "../features/financeiro/presentation/pages/SaldoBancario_lista";
import { SaldoBancarioCadastro } from "../features/financeiro/presentation/pages/SaldoBancario_cadastro";
import { ObrasChecklistarea } from "../features/obras/presentation/pages/Obras_checklistarea";
import { FinanceiroReajustesLista } from "../features/financeiro/presentation/pages/FinanceiroReajustes_lista";
import { FinanceiroReajusteCadastro } from "../features/financeiro/presentation/pages/FinanceiroReajuste_cadastro";
import { Auditorias } from "../features/auditoria/presentation/pages/Auditoria_auditorias";
import { Acoes_Melhorias } from "../features/qualidade/presentation/pages/Acoes_melhorias";
import { FinanceiroContratosLista } from "../features/financeiro/presentation/pages/FinanceiroContratos_lista";
import { FinanceiroContratosCadastro } from "../features/financeiro/presentation/pages/FinanceiroContratos_cadastro";
import { CadastroAcoesPreventivas } from "../features/qualidade/presentation/pages/cadastro_acoes_melhorias";
import { Acoes_Corretivas } from "../features/qualidade/presentation/pages/Acoes_corretivas";
import { CadastroAcoesCorretivas } from "../features/qualidade/presentation/pages/cadastro_acoes_corretivas";
import { CronogramaSGQ_lista } from "../features/qualidade/presentation/pages/CronogramaSGQ_lista";
import { AtributosObrasCadastro } from "../features/obras/presentation/pages/AtributosObras_cadastro";
import { ProjetosLista } from "../features/projetos/presentation/pages/Projetos_lista";
import { ChecklistServicoLista } from "../features/obras/presentation/pages/ChecklistServico_lista";
import { ChecklistServicoItensCadastro } from "../features/obras/presentation/pages/ChecklistServicoItens_cadastro";
import { ChecklistServicoObrasItem } from "../features/obras/presentation/pages/ChecklistServico_obrasItem";
import { FornecedoresLista } from "../features/compras/presentation/pages/Fornecedores_lista";
import { Checklist_Lista } from "../features/projetos/presentation/pages/Checklist_lista";
import { ChecklistItensCadastro } from "../features/projetos/presentation/pages/ChecklistItens_cadastro";
import { ProjetosCadastro } from "../features/projetos/presentation/pages/Projetos_cadastro";
import { FornecedoresCadastro } from "../features/compras/presentation/pages/Fornecedores_cadastro";
import { ServicosProdutosLista } from "../features/compras/presentation/pages/ServicosProdutos_lista";
import { RequisicaoServicosProdutosLista } from "../features/compras/presentation/pages/RequisicaoServicosProdutos_lista";
import { RequisicaoServicosProdutosCadastro } from "../features/compras/presentation/pages/RequisicaoServicosProdutos_cadastro";
import { RateioGeralCadastro } from "../features/financeiro/presentation/pages/RateioGeral_cadastro";
import { ProvisaoRecurso } from "../features/qualidade/presentation/pages/Provisao_Recurso";
import { Indicadores_Lista } from "../features/qualidade/presentation/pages/Indicadores";
import { GedQualidade } from "../features/qualidade/presentation/pages/GED_qualidade";
import { ProcessosRiscos } from "../features/qualidade/presentation/pages/ProcessosRiscos";
import { ProcessosRiscosItens } from "../features/qualidade/presentation/pages/ProcessosRiscosItens";
import { CadastroProcessosRiscosItens } from "../features/qualidade/presentation/pages/CadastroProcessosRiscosItens";
import { ColetaPrecosLista } from "../features/compras/presentation/pages/ColetaPrecos_lista";
import { ColetaPrecosCadastro } from "../features/compras/presentation/pages/ColetaPrecos_cadastro";
import { OrdemComprasCadastro } from "../features/compras/presentation/pages/OrdemCompras_cadastro";
import { ClientesLista } from "../features/comercial/presentation/pages/Clientes_lista";
import { ClientesCadastro } from "../features/comercial/presentation/pages/Clientes_cadastro";
import { NovosNegociosLista } from "../features/comercial/presentation/pages/NovosNegocios_lista";
import { NovosNegociosCadastro } from "../features/comercial/presentation/pages/NovosNegocios_cadastro";
import { DiarioObra_lista } from "../features/diarioObra/presentation/pages/DiarioObra_lista";
import { DiarioObra_Cadastro } from "../features/diarioObra/presentation/pages/DiarioObra_cadastro";
import { OrdemComprasLista } from "../features/compras/presentation/pages/OrdemCompras_lista";
import { SubcontasLista } from "../features/comercial/presentation/pages/Subconta_lista";
import { OrdemComprasEntrega } from "../features/compras/presentation/pages/OrdemCompras_entrega";
import { AvaliacaoFornecedorCadastro } from "../features/compras/presentation/pages/AvaliacaoFornecedor_cadastro";
import { OrdemCompraListaCancelar } from "../features/compras/presentation/pages/OrdemCompra_lista_cancelar";
import { OrdemCompraCancelar } from "../features/compras/presentation/pages/OrdemCompra_cancelar";
import { OrdemCompraConsultarPrecos } from "../features/compras/presentation/pages/OrdemCompra_consultarPrecos";
import { AtributosComprasCadastro } from "../features/compras/presentation/pages/AtributosCompras_cadastro";
import { GedCompras } from "../features/compras/presentation/pages/GED_compras";
import { GedExternos } from "../features/controleDocumentos/presentation/pages/GED_externos";
import { GedInternos } from "../features/controleDocumentos/presentation/pages/GED_internos";
import { MaquinasEquip_lista } from "../features/controledePatrimonio/presentation/pages/MaquinasEquip_lista";
import { MaquinasEquipControle } from "../features/controledePatrimonio/presentation/pages/MaquinasEquip_controle";
import { MaquinasEquipItensControle } from "../features/controledePatrimonio/presentation/pages/MaquinasEquipItens_controle";
import { RateioGeralLista } from "../features/financeiro/presentation/pages/RateioGeral_lista";
import { Contrato_Cadastro } from "../features/terceirizacao/presentation/pages/Contrato_cadastro";
import { GedTerceirizacao } from "../features/terceirizacao/presentation/pages/GED_terceirizacao";
import { MedicaoTerceirizacao_lista } from "../features/terceirizacao/presentation/pages/Medicao_terceirizacao_lista";
import { MedicaoTerceirizacao_Cadastro } from "../features/terceirizacao/presentation/pages/Medicao_terceirizacao_cadastro";
import { AvaliacaoFornecimento_lista } from "../features/terceirizacao/presentation/pages/Avaliacao_Fornecimento_lista";
import { FuncionariosTercerizacaoLista } from "../features/terceirizacao/presentation/pages/FuncionariosTercerizacao_lista";
import { FuncionariosTercCadastro } from "../features/terceirizacao/presentation/pages/Funcionarios_cadastro";
import { ChecklistEntregaLista } from "../features/entregaObras/presentation/pages/ChecklistEntrega_lista";
import { UsuariosLista } from "../features/administracao/presentation/pages/Usuarios_lista";
import { UsuariosCadastro } from "../features/administracao/presentation/pages/Usuarios_cadastro";
import { PermissaoAcessoCadastro } from "../features/administracao/presentation/pages/PermissaoAcesso_cadastro";
import { AtributosSistemaCadastro } from "../features/administracao/presentation/pages/AtributosSistema_cadastro";
import { Contrato_lista } from "../features/terceirizacao/presentation/pages/Contrato_lista";
import { CronogramaItensChecklist_cadastro } from "../features/projetos/presentation/pages/CronogramaItensChecklist_cadastro";
import { GestaoTreinamentosTercLista } from "../features/terceirizacao/presentation/pages/GestaoTreinamentos_lista";
import { GestaoTreinamentosTercCadastro } from "../features/terceirizacao/presentation/pages/GestaoTreinamentos_cadastro";
import { AvaliacaoTreinamentoTercLoteCadastro } from "../features/terceirizacao/presentation/pages/AvaliacaoTreinamentoLote_cadastro";
import { TreinamentoFuncionarioTercCadastro } from "../features/terceirizacao/presentation/pages/TreinamentoFuncionario_cadastro";
import { AvaliacaoFornecimento } from "../features/terceirizacao/presentation/pages/Avaliacao_fornecimento";
import { PesquisaClienteLista } from "../features/entregaObras/presentation/pages/PesquisaCliente_lista";
import { SatisfacaoClientePesquisaLista } from "../features/entregaObras/presentation/pages/SatisfacaoClientePesquisa_lista";
import { TermoLista } from "../features/entregaObras/presentation/pages/Termo_lista";
import { CadastroPesquisaLista } from "../features/entregaObras/presentation/pages/CadastroPesquisa_lista";
import { CadastroPesquisaItensCadastro } from "../features/entregaObras/presentation/pages/CadastroPesquisaItens_cadastro";
import { CategoriaAssistenciaLista } from "../features/entregaObras/presentation/pages/CategoriaAssistencia_lista";
import { AssistenciaTecnicaLista } from "../features/entregaObras/presentation/pages/AssistenciaTecnica_lista";
import { AssistenciaTecnicaCadastro } from "../features/entregaObras/presentation/pages/AssistenciaTecnica_cadastro";
import { Obras_sustentabilidade } from "../features/obras/presentation/pages/Obras_sustentabilidade";
import { Impressao_listagerenciar } from "../features/projetos/presentation/pages/Impressao_listagerenciar";
import { Impressao_listasolicitar } from "../features/projetos/presentation/pages/Impressao_listasolicitar";
import { Impressao_cadastrosolicitar } from "../features/projetos/presentation/pages/Impressao_cadastrosolicitar";
import { EntregaObrasLista } from "../features/entregaObras/presentation/pages/EntregaObras_lista";
import { EntregaObrasClienteLista } from "../features/entregaObras/presentation/pages/EntregaObrasCliente_lista";
import { EntregaObrasClienteVerificacao } from "../features/entregaObras/presentation/pages/EntregaObraCliente_verificacao";
import { GedEntregaObras } from "../features/entregaObras/presentation/pages/GED_entregaobras";
import { AuditoresCadastro } from "../features/auditoria/presentation/pages/Auditores_cadastro";
import { AuditoriasCadastro } from "../features/auditoria/presentation/pages/Auditoria_cadastro";
import { GedAuditoria } from "../features/auditoria/presentation/pages/GED_auditoria";
import { MaquinasEquipItensVerificacao } from "../features/controledePatrimonio/presentation/pages/MaquinasEquipItens_verificacao";
import { MaquinasEquipItensCadastro } from "../features/controledePatrimonio/presentation/pages/MaquinasEquipItens_cadastro";
import { EntradaProdutosLista } from "../features/controleEstoque/presentation/pages/EntradaProdutos_lista";
import { SaidaProdutosLista } from "../features/controleEstoque/presentation/pages/SaidaProdutos_lista";
import { ControleEstoqueLista } from "../features/controleEstoque/presentation/pages/ControleEstoque_lista";
import { ItensControleLista } from "../features/controleEstoque/presentation/pages/ControleEstoque_cadastro";
import { Revisao_listasolicitar } from "../features/projetos/presentation/pages/Revisao_listasolicitar";
import { Revisao_listagerenciar } from "../features/projetos/presentation/pages/Revisao_listagerenciar";
import { Revisao_cadastrosolicitar } from "../features/projetos/presentation/pages/Revisao_cadastrosolicitar";
import { Revisao_cadastrogerenciar } from "../features/projetos/presentation/pages/Revisao_cadastrogerenciar";
import { GedMaquinasEquip } from "../features/controledePatrimonio/presentation/pages/GED_maquinasequip";
import { GedObras } from "../features/obras/presentation/pages/GED_obras";
import { GedComercial } from "../features/comercial/presentation/pages/GED_comercial";
import { GedFinanceiro } from "../features/financeiro/presentation/pages/GED_financeiro";
import { GedEquipamentoMedicoes } from "../features/equipamentoMedicoes/presentation/pages/GED_equipamento_medicoes";
import { GedProjetos } from "../features/projetos/presentation/pages/GED_projetos";
import { MaquinasequipCadastroPrincipal } from "../features/controledePatrimonio/presentation/pages/Maquinasequip_cadastroprincipal";
import { Impressao_cadastrogerenciar } from "../features/projetos/presentation/pages/Impressao_cadastrogerenciar";
import { PrincipalRh } from "../features/rh/presentation/pages/Principal_rh";
import { PrincipalCompras } from "../features/compras/presentation/pages/Principal_compras";
import { PrincipalAuditoria } from "../features/auditoria/presentation/pages/Principal";
import { PrincipalFinanceiro } from "../features/financeiro/presentation/pages/Principal_financeiro";
import { PrincipalQualidade } from "../features/qualidade/presentation/pages/Principal";
import { PrincipalDiarioObras } from "../features/diarioObra/presentation/pages/Principal";
import { PrincipalEquipamentoMedicoes } from "../features/equipamentoMedicoes/presentation/pages/Principal";
import { PrincipalObras } from "../features/obras/presentation/pages/Principal_obras";
import { PrincipalTercerizacao } from "../features/terceirizacao/presentation/pages/Principal";
import { PrincipalControlePatrimonio } from "../features/controledePatrimonio/presentation/pages/Principal";
import { PrincipalEntregaObras } from "../features/entregaObras/presentation/pages/Principal_entregaobras";
import { PrincipalComercial } from "../features/comercial/presentation/pages/Principal_comercial";
import { PrincipalControleDocumentos } from "../features/controleDocumentos/presentation/pages/Principal_controledocumentos";
import { PrincipalProjetos } from "../features/projetos/presentation/pages/Principal_projetos";
import { ChecklistEntregaItensCadastro } from "../features/entregaObras/presentation/pages/ChecklistEntregaItens_cadastro";
import { ManutencaoSolicitacaoLista } from "../features/controledePatrimonio/presentation/pages/ManutencaoSolicitacao_lista";
import { ManutencaoGerenciarLista } from "../features/controledePatrimonio/presentation/pages/ManutencaoGerenciar_lista";
import { ManutencaoSolicitacaoCadastro } from "../features/controledePatrimonio/presentation/pages/ManutencaoSolicitacao_cadastro";
import { ManutencaoGerenciarCadastro } from "../features/controledePatrimonio/presentation/pages/ManutencaoGerenciar_cadastro";
import { IndicadoresServicosObras } from "../features/obras/presentation/pages/IndicadoresServicosObras";
import { ChecklistEntregaAmbienteLista } from "../features/entregaObras/presentation/pages/ChecklistEntregaAmbiente_lista";
import { ObrasDocumentos } from "../features/obras/presentation/pages/Obras_documentos";
import { CadastroEpiLista } from "../features/gestaoEpi/presentation/pages/CadastroEpi_lista";
import { ControleRecebimentoEpiLista } from "../features/gestaoEpi/presentation/pages/ControleRecebimentoEpi_lista";
import { DistribuicaoEpiLista } from "../features/gestaoEpi/presentation/pages/DistribuicaoEpi_lista";
import { PrincipalGestaoEPI } from "../features/gestaoEpi/presentation/pages/GestaoEpi_principal";
import { ChecklistServicoAmbienteLista } from "../features/obras/presentation/pages/ChecklistServicoAmbiente_lista";
import { CadastroCoresLista } from "../features/equipamentoMedicoes/presentation/pages/CadastroCores_lista";
import { CadastroAprovadoresLista } from "../features/compras/presentation/pages/CadastroAprovadores_lista";
import { ChecklistMaquinaEquipLista } from "../features/controledePatrimonio/presentation/pages/ChecklistMaquinaEquip_lista";
import { ChecklistMaquinaEquipItensCadastro } from "../features/controledePatrimonio/presentation/pages/ChecklistMaquinaEquipItens_cadastro";
import { ChatPage } from "../features/ChatPage";
import { PatrimonioCentroCustoLista } from "../features/controledePatrimonio/presentation/pages/Patrimonio_maquinaEquip";
import { PatrimonioCadastroInspecao } from "../features/controledePatrimonio/presentation/pages/PatrimonioCadastro_inspecao";
import { PatrimonioItensInspecaoCadastro } from "../features/controledePatrimonio/presentation/pages/PatrimonioItensInspecao_cadastro";
import { PatrimonioItensInspecaoVerificacao } from "../features/controledePatrimonio/presentation/pages/PatrimonioItensInspecao_verificacao";
import { TermoEpiLista } from "../features/gestaoEpi/presentation/pages/TermoEpi_lista";
import { Empreendimento_lista } from "../features/incorporacao/presentation/pages/Empreendimento_lista";
import { EmpreendimentoCadastro } from "../features/incorporacao/presentation/pages/Empreendimento_cadastro";
import { ObrasConcretagemCadastro } from "../features/obras/presentation/pages/Obras_concretagem_cadastro";
import { EmpreendimentoUnidadeCadastro } from "../features/obras/presentation/pages/EmpreendimentoUnidade_cadastro";
import { EmpreendimentoUnidadeItens } from "../features/obras/presentation/pages/EmpreendimentoUnidade_itens";
import { ChecklistServicoLiberacaoLista } from "../features/obras/presentation/pages/ChecklistServicoLiberacao_lista";

import Dashboard from "../pages/dashboard/Dashboard";
import ProtectedRoute from "./ProtectedRoute";
import GuestRoute from "./GuestRoute";
import ConfigureLogin from "../pages/auth/ConfigureLogin";
import FuncionarioList from "../pages/rh/FuncionarioList";
import FuncionarioRegister from "../pages/rh/FuncionarioRegister";
import CargoList from "../pages/rh/CargoList";
import CargoRegister from "../pages/rh/CargoRegister";
import AcessoNegado from "../pages/administracao/AcessoNegado";
import Login from "../pages/auth/Login";

/**
 * Router
 */

function Router() {
  return (
    <>
      <Routes>

        <Route
          path="/ManutencaoSolicitacao_lista"
          element={
            <ProtectedRoute>
              <ManutencaoSolicitacaoLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/ManutencaoGerenciar_lista"
          element={
            <ProtectedRoute>
              <ManutencaoGerenciarLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/ManutencaoSolicitacao_cadastro"
          element={
            <ProtectedRoute>
              <ManutencaoSolicitacaoCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/ManutencaoGerenciar_cadastro"
          element={
            <ProtectedRoute>
              <ManutencaoGerenciarCadastro />
            </ProtectedRoute>
          }
        />

        {/* Nova arquitetura */}

        <Route
          path="/EquipamentoMedicao_lista"
          element={
            <ProtectedRoute>
              <EquipamentoMedicao_lista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/MaquinasEquip_lista"
          element={
            <ProtectedRoute>
              <MaquinasEquip_lista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Principal_maquinasequip"
          element={
            <ProtectedRoute>
              <PrincipalControlePatrimonio />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Principal_equipamentomedicao"
          element={
            <ProtectedRoute>
              <PrincipalEquipamentoMedicoes />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Revisao_listasolicitar"
          element={
            <ProtectedRoute>
              <Revisao_listasolicitar />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Revisao_cadastrogerenciar"
          element={
            <ProtectedRoute>
              <Revisao_cadastrogerenciar />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Revisao_cadastrosolicitar"
          element={
            <ProtectedRoute>
              <Revisao_cadastrosolicitar />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Revisao_listagerenciar"
          element={
            <ProtectedRoute>
              <Revisao_listagerenciar />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Impressao_listagerenciar"
          element={
            <ProtectedRoute>
              <Impressao_listagerenciar />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Impressao_cadastrogerenciar"
          element={
            <ProtectedRoute>
              <Impressao_cadastrogerenciar />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Impressao_listasolicitar"
          element={
            <ProtectedRoute>
              <Impressao_listasolicitar />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Impressao_cadastrosolicitar"
          element={
            <ProtectedRoute>
              <Impressao_cadastrosolicitar />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Obras_sustentabilidade"
          element={
            <ProtectedRoute>
              <Obras_sustentabilidade />
            </ProtectedRoute>
          }
        />
        <Route
          path="/MaquinasEquip_controle"
          element={
            <ProtectedRoute>
              <MaquinasEquipControle />
            </ProtectedRoute>
          }
        />
        <Route
          path="/MaquinasEquipItens_verificacao"
          element={
            <ProtectedRoute>
              <MaquinasEquipItensVerificacao />
            </ProtectedRoute>
          }
        />
        <Route
          path="/CronogramaItensChecklist_cadastro/:id?/:idProjeto?"
          element={
            <ProtectedRoute>
              <CronogramaItensChecklist_cadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Patrimonio_maquinaEquip"
          element={
            <ProtectedRoute>
              <PatrimonioCentroCustoLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Patrimonio_cadastroInspecao/:id?"
          element={
            <ProtectedRoute>
              <PatrimonioCadastroInspecao />
            </ProtectedRoute>
          }
        />

        <Route
          path="/PatrimonioItensInspecao_cadastro/:id?"
          element={
            <ProtectedRoute>
              <PatrimonioItensInspecaoCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/PatrimonioItensInspecao_verificacao/:id?/:idPatrimonioMaquinaEquip?/:idInspecaoPatrimonio?"
          element={
            <ProtectedRoute>
              <PatrimonioItensInspecaoVerificacao />
            </ProtectedRoute>
          }
        />

        <Route
          path="/ChecklistMaquinaEquip_lista"
          element={
            <ProtectedRoute>
              <ChecklistMaquinaEquipLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/ChecklistMaquinaEquipItens_cadastro/:id?/:idMaquinaEquip?"
          element={
            <ProtectedRoute>
              <ChecklistMaquinaEquipItensCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/MaquinasEquipItens_controle"
          element={
            <ProtectedRoute>
              <MaquinasEquipItensControle />
            </ProtectedRoute>
          }
        />

        <Route
          path="/MaquinasEquip_cadastroprincipal"
          element={
            <ProtectedRoute>
              <MaquinasequipCadastroPrincipal />
            </ProtectedRoute>
          }
        />

        <Route
          path="/login"
          element={
            <GuestRoute>
              <NewLogin />
            </GuestRoute>
          }
        />

        <Route
          path="/configure"
          element={
            <GuestRoute>
              <NewConfigureLogin />
            </GuestRoute>
          }
        />

        <Route
          path="/GruposAcesso_lista"
          element={
            <ProtectedRoute>
              <GrupoAcessoLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/PermissaoAcesso_cadastro"
          element={
            <ProtectedRoute>
              <PermissaoAcessoCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Principal_projetos"
          element={
            <ProtectedRoute>
              <PrincipalProjetos />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Projetos_lista"
          element={
            <ProtectedRoute>
              <ProjetosLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Projetos_cadastro/:id?/:tab?"
          element={
            <ProtectedRoute>
              <ProjetosCadastro />
            </ProtectedRoute>
          }
        />
        <Route
          path="/MaquinasEquipItens_cadastro"
          element={
            <ProtectedRoute>
              <MaquinasEquipItensCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Checklist_lista"
          element={
            <ProtectedRoute>
              <Checklist_Lista />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ChecklistItens_cadastro/:id?"
          element={
            <ProtectedRoute>
              <ChecklistItensCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/GruposAcesso_cadastro"
          element={
            <ProtectedRoute>
              <GruposAcessoCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Funcionarios_lista"
          element={
            <ProtectedRoute>
              <FuncionariosLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Funcionarios_cadastro"
          element={
            <ProtectedRoute>
              <FuncionariosCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/MotivoDemissao_lista"
          element={
            <ProtectedRoute>
              <MotivoDemissaoLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/CadastroAssinaturas_lista"
          element={
            <ProtectedRoute>
              <CadastroAssinaturaLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/AtributosObras_cadastro"
          element={
            <ProtectedRoute>
              <AtributosObrasCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/MotivoAfastamento_lista"
          element={
            <ProtectedRoute>
              <MotivoAfastamentoLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Principal_financeiro"
          element={
            <ProtectedRoute>
              <PrincipalFinanceiro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/ContasReceber_lista"
          element={
            <ProtectedRoute>
              <ContasReceberLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/ContasReceber_deletadas"
          element={
            <ProtectedRoute>
              <ContasReceberDeletadas />
            </ProtectedRoute>
          }
        />

        <Route
          path="/ContasReceber_cadastro"
          element={
            <ProtectedRoute>
              <ContasReceberCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Empreendimento_lista"
          element={
            <ProtectedRoute>
              <Empreendimento_lista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Empreendimento_cadastro"
          element={
            <ProtectedRoute>
              <EmpreendimentoCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/EmpreendimentoUnidade_cadastro"
          element={
            <ProtectedRoute>
              <EmpreendimentoUnidadeCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/EmpreendimentoUnidade_itens"
          element={
            <ProtectedRoute>
              <EmpreendimentoUnidadeItens />
            </ProtectedRoute>
          }
        />

        <Route
          path="/ContasPagar_lista"
          element={
            <ProtectedRoute>
              <ContasPagarLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/ContasPagar_deletadas"
          element={
            <ProtectedRoute>
              <ContasPagarDeletadas />
            </ProtectedRoute>
          }
        />

        <Route
          path="/ContasPagar_cadastro"
          element={
            <ProtectedRoute>
              <ContasPagarCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/BancoPagamento_lista"
          element={
            <ProtectedRoute>
              <BancoPagamentoLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/SaldoBancario_lista"
          element={
            <ProtectedRoute>
              <SaldoBancarioLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/SaldoBancario_cadastro"
          element={
            <ProtectedRoute>
              <SaldoBancarioCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/ContasReceber_cadastro"
          element={
            <ProtectedRoute>
              <ContasReceberCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/FinanceiroReajustes_lista"
          element={
            <ProtectedRoute>
              <FinanceiroReajustesLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/FinanceiroReajuste_cadastro"
          element={
            <ProtectedRoute>
              <FinanceiroReajusteCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/FinanceiroContratos_lista"
          element={
            <ProtectedRoute>
              <FinanceiroContratosLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/FinanceiroContratos_cadastro"
          element={
            <ProtectedRoute>
              <FinanceiroContratosCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/RateioGeral_lista"
          element={
            <ProtectedRoute>
              <RateioGeralLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/RateioGeral_cadastro"
          element={
            <ProtectedRoute>
              <RateioGeralCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/CentroCusto_cadastro"
          element={
            <ProtectedRoute>
              <CentroCusto_cadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/CentroCusto_lista"
          element={
            <ProtectedRoute>
              <CentroCustoLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Clientes_lista"
          element={
            <ProtectedRoute>
              <ClientesLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Clientes_cadastro"
          element={
            <ProtectedRoute>
              <ClientesCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/NovosNegocios_lista"
          element={
            <ProtectedRoute>
              <NovosNegociosLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/NovosNegocios_cadastro"
          element={
            <ProtectedRoute>
              <NovosNegociosCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Subcontas_lista"
          element={
            <ProtectedRoute>
              <SubcontasLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/EntregaObras_lista"
          element={
            <ProtectedRoute>
              <EntregaObrasLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/EntregaObrasCliente_lista"
          element={
            <ProtectedRoute>
              <EntregaObrasClienteLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/EntregaObrasCliente_verificacao"
          element={
            <ProtectedRoute>
              <EntregaObrasClienteVerificacao />
            </ProtectedRoute>
          }
        />

        <Route
          path="/ChecklistEntrega_lista"
          element={
            <ProtectedRoute>
              <ChecklistEntregaLista />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ChecklistEntregaAmbiente_lista/:id?"
          element={
            <ProtectedRoute>
              <ChecklistEntregaAmbienteLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/ChecklistEntregaItens_cadastro/:id?"
          element={
            <ProtectedRoute>
              <ChecklistEntregaItensCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Cargos_lista"
          element={
            <ProtectedRoute>
              <CargosLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Termo_lista"
          element={
            <ProtectedRoute>
              <TermoLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Cargos_cadastro"
          element={
            <ProtectedRoute>
              <CargosCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Treinamentos_lista"
          element={
            <ProtectedRoute>
              <TreinamentosLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/TreinamentoCargo_cadastro"
          element={
            <ProtectedRoute>
              <TreinamentoCargoCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Habilidades_lista"
          element={
            <ProtectedRoute>
              <HabilidadesLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/HabilidadeCargo_cadastro"
          element={
            <ProtectedRoute>
              <HabilidadeCargoCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/GestaoTreinamentos_lista"
          element={
            <ProtectedRoute>
              <GestaoTreinamentosLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/GestaoTreinamentos_cadastro"
          element={
            <ProtectedRoute>
              <GestaoTreinamentosCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/AvaliacaoTreinamentoLote_cadastro"
          element={
            <ProtectedRoute>
              <AvaliacaoTreinamentoLoteCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/TreinamentoFuncionario_cadastro"
          element={
            <ProtectedRoute>
              <TreinamentoFuncionarioCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/FolhaPagamento_lista"
          element={
            <ProtectedRoute>
              <FolhaPagamentoLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/FolhaPagamento_cadastro"
          element={
            <ProtectedRoute>
              <FolhaPagamentoCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/TreinamentoFuncionario_cadastro"
          element={
            <ProtectedRoute>
              <TreinamentoFuncionarioCadastro />
            </ProtectedRoute>
          }
        />
        <Route
          path="/FolhaPagamento_itensverba"
          element={
            <ProtectedRoute>
              <FolhaPagamentoItensVerba />
            </ProtectedRoute>
          }
        />

        <Route
          path="/VerbaPagamento_lista"
          element={
            <ProtectedRoute>
              <VerbaPagamentoLista />
            </ProtectedRoute>
          }
        />
        <Route
          path="/GED_rh"
          element={
            <ProtectedRoute>
              <GedRh />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ProcessosRiscos_lista"
          element={
            <ProtectedRoute>
              <ProcessosRiscos />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ProcessosRiscos_listaitens/:id?"
          element={
            <ProtectedRoute>
              <ProcessosRiscosItens />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ProcessosRiscos_cadastroitens/:id?/:IdItem?"
          element={
            <ProtectedRoute>
              <CadastroProcessosRiscosItens />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Principal_auditoria"
          element={
            <ProtectedRoute>
              <PrincipalAuditoria />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Auditores_lista"
          element={
            <ProtectedRoute>
              <Auditores />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Auditores_cadastro/:id?"
          element={
            <ProtectedRoute>
              <AuditoresCadastro />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Auditorias_lista/:s?"
          element={
            <ProtectedRoute>
              <Auditorias />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Auditorias_cadastro/:id?"
          element={
            <ProtectedRoute>
              <AuditoriasCadastro />
            </ProtectedRoute>
          }
        />
        <Route
          path="/GED_auditoria"
          element={
            <ProtectedRoute>
              <GedAuditoria />
            </ProtectedRoute>
          }
        />
        <Route
          path="/AcoesPreventivas_lista/:status?"
          element={
            <ProtectedRoute>
              <Acoes_Melhorias />
            </ProtectedRoute>
          }
        />
        <Route
          path="/AcoesPreventivas_Cadastro/:tipo?/:id?"
          element={
            <ProtectedRoute>
              <CadastroAcoesPreventivas />
            </ProtectedRoute>
          }
        />
        <Route
          path="/AcoesCorretivas_lista/:status?"
          element={
            <ProtectedRoute>
              <Acoes_Corretivas />
            </ProtectedRoute>
          }
        />
        <Route
          path="/AcoesCorretivas_Cadastro/:tipo?/:id?"
          element={
            <ProtectedRoute>
              <CadastroAcoesCorretivas />
            </ProtectedRoute>
          }
        />
        <Route
          path="/CronogramaSGQ_lista/:status?"
          element={
            <ProtectedRoute>
              <CronogramaSGQ_lista />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ProvisaoRecurso_lista/"
          element={
            <ProtectedRoute>
              <ProvisaoRecurso />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Indicadores_lista/"
          element={
            <ProtectedRoute>
              <Indicadores_Lista />
            </ProtectedRoute>
          }
        />
        <Route
          path="/GED_qualidade/"
          element={
            <ProtectedRoute>
              <GedQualidade />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Principal_qualidade/"
          element={
            <ProtectedRoute>
              <PrincipalQualidade />
            </ProtectedRoute>
          }
        />
        <Route
          path="/DiarioObra_lista/:d?/:pendentes?"
          element={
            <ProtectedRoute>
              <DiarioObra_lista />
            </ProtectedRoute>
          }
        />
        <Route
          path="/DiarioObra_cadastro/:id?"
          element={
            <ProtectedRoute>
              <DiarioObra_Cadastro />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Principal_diarioObra/"
          element={
            <ProtectedRoute>
              <PrincipalDiarioObras />
            </ProtectedRoute>
          }
        />
        <Route
          path="/EntradaProdutos_lista/"
          element={
            <ProtectedRoute>
              <EntradaProdutosLista />
            </ProtectedRoute>
          }
        />
        <Route
          path="/SaidaProdutos_lista/"
          element={
            <ProtectedRoute>
              <SaidaProdutosLista />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ControleEstoque_lista/"
          element={
            <ProtectedRoute>
              <ControleEstoqueLista />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ControleEstoque_cadastro/:id?"
          element={
            <ProtectedRoute>
              <ItensControleLista />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Contrato_lista/:d?/:s?"
          element={
            <ProtectedRoute>
              <Contrato_lista />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Contrato_Cadastro/:id?"
          element={
            <ProtectedRoute>
              <Contrato_Cadastro />
            </ProtectedRoute>
          }
        />
        <Route
          path="/GED_terceirizacao/:id?"
          element={
            <ProtectedRoute>
              <GedTerceirizacao />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Principal_terceirizacao/"
          element={
            <ProtectedRoute>
              <PrincipalTercerizacao />
            </ProtectedRoute>
          }
        />
        <Route
          path="/MedicaoTerceirizacao_lista/:s?"
          element={
            <ProtectedRoute>
              <MedicaoTerceirizacao_lista />
            </ProtectedRoute>
          }
        />
        <Route
          path="/MedicaoTerceirizacao_cadastro/:id?"
          element={
            <ProtectedRoute>
              <MedicaoTerceirizacao_Cadastro />
            </ProtectedRoute>
          }
        />
        <Route
          path="/MedicaoTerceirizacao_entrega/"
          element={
            <ProtectedRoute>
              <AvaliacaoFornecimento_lista />
            </ProtectedRoute>
          }
        />
        <Route
          path="/MedicaoTerceirizacao_avaliacafornecimento/:id?"
          element={
            <ProtectedRoute>
              <AvaliacaoFornecimento />
            </ProtectedRoute>
          }
        />
        <Route
          path="/FuncionarioTercerizacao_lista/:d?/:av?/:s?"
          element={
            <ProtectedRoute>
              <FuncionariosTercerizacaoLista />
            </ProtectedRoute>
          }
        />
        <Route
          path="/FuncionarioTercerizacao_cadastro/:id?"
          element={
            <ProtectedRoute>
              <FuncionariosTercCadastro />
            </ProtectedRoute>
          }
        />
        <Route
          path="/GestaoTreinamentosTerceirizacao_lista/"
          element={
            <ProtectedRoute>
              <GestaoTreinamentosTercLista />
            </ProtectedRoute>
          }
        />
        <Route
          path="/GestaoTreinamentosTerceirizacao_cadastro/:id?"
          element={
            <ProtectedRoute>
              <GestaoTreinamentosTercCadastro />
            </ProtectedRoute>
          }
        />
        <Route
          path="/AvaliacaoTreinamentoLoteTerceirizacao_cadastro/"
          element={
            <ProtectedRoute>
              <AvaliacaoTreinamentoTercLoteCadastro />
            </ProtectedRoute>
          }
        />
        <Route
          path="/TreinamentoFuncionarioTerceirizacao_cadastro/"
          element={
            <ProtectedRoute>
              <TreinamentoFuncionarioTercCadastro />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Obras_lista"
          element={
            <ProtectedRoute>
              <ObrasLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Obras_informacoesgerais"
          element={
            <ProtectedRoute>
              <ObrasInformacoesGerais />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Obras_gestao_servicos"
          element={
            <ProtectedRoute>
              <ObrasGestaoServicos />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Obras_equipamentosmedicao"
          element={
            <ProtectedRoute>
              <ObrasEquipamentoMedicao />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Obras_maquinasequipamentos"
          element={
            <ProtectedRoute>
              <Obrasmaquinasequipamentos />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Obras_gestaoresiduos"
          element={
            <ProtectedRoute>
              <ObrasGestaoResiduos />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Obras_materiaiscontrolados"
          element={
            <ProtectedRoute>
              <ObrasMateriaisControlados />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Obras_servicoscontrolados"
          element={
            <ProtectedRoute>
              <ObrasServicosControlados />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Obras_concretagem"
          element={
            <ProtectedRoute>
              <ObrasConcretagem />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Obras_treinamentos"
          element={
            <ProtectedRoute>
              <ObrasTreinamento />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Obras_alvenariaestrutural"
          element={
            <ProtectedRoute>
              <ObrasAlvenariaEstrutural />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Obras_cadastroarea"
          element={
            <ProtectedRoute>
              <ObrasCadastroarea />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Obras_checklistarea"
          element={
            <ProtectedRoute>
              <ObrasChecklistarea />
            </ProtectedRoute>
          }
        />

        <Route
          path="/ObraItensChecklistArea_cadastro"
          element={
            <ProtectedRoute>
              <ObraItensChecklistAreaCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/ObraItensChecklistArea_verificacao"
          element={
            <ProtectedRoute>
              <ObraItensChecklistAreaVerificacao />
            </ProtectedRoute>
          }
        />

        <Route
          path="/ChecklistServico_lista"
          element={
            <ProtectedRoute>
              <ChecklistServicoLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/ChecklistServicoAmbiente_lista"
          element={
            <ProtectedRoute>
              <ChecklistServicoAmbienteLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/ChecklistServicoItens_cadastro"
          element={
            <ProtectedRoute>
              <ChecklistServicoItensCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/ChecklistServico_obrasItem"
          element={
            <ProtectedRoute>
              <ChecklistServicoObrasItem />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Fornecedores_lista"
          element={
            <ProtectedRoute>
              <FornecedoresLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Fornecedores_cadastro"
          element={
            <ProtectedRoute>
              <FornecedoresCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/ServicosProdutos_lista"
          element={
            <ProtectedRoute>
              <ServicosProdutosLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/RequisicaoServicosProdutos_lista"
          element={
            <ProtectedRoute>
              <RequisicaoServicosProdutosLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/RequisicaoServicosProdutos_cadastro"
          element={
            <ProtectedRoute>
              <RequisicaoServicosProdutosCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/ColetaPrecos_lista"
          element={
            <ProtectedRoute>
              <ColetaPrecosLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/ColetaPrecos_cadastro"
          element={
            <ProtectedRoute>
              <ColetaPrecosCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/OrdemCompras_cadastro"
          element={
            <ProtectedRoute>
              <OrdemComprasCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/OrdemCompras_lista"
          element={
            <ProtectedRoute>
              <OrdemComprasLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Usuarios_lista"
          element={
            <ProtectedRoute>
              <UsuariosLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/OrdemCompras_entrega"
          element={
            <ProtectedRoute>
              <OrdemComprasEntrega />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Usuarios_cadastro"
          element={
            <ProtectedRoute>
              <UsuariosCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/AvaliacaoFornecedor_cadastro"
          element={
            <ProtectedRoute>
              <AvaliacaoFornecedorCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/AtributosSistema_cadastro"
          element={
            <ProtectedRoute>
              <AtributosSistemaCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/OrdemCompra_lista_cancelar"
          element={
            <ProtectedRoute>
              <OrdemCompraListaCancelar />
            </ProtectedRoute>
          }
        />

        <Route
          path="/OrdemCompra_cancelar"
          element={
            <ProtectedRoute>
              <OrdemCompraCancelar />
            </ProtectedRoute>
          }
        />

        <Route
          path="/OrdemCompra_consultarPrecos"
          element={
            <ProtectedRoute>
              <OrdemCompraConsultarPrecos />
            </ProtectedRoute>
          }
        />

        <Route
          path="/AtributosCompras_cadastro"
          element={
            <ProtectedRoute>
              <AtributosComprasCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/GED_compras"
          element={
            <ProtectedRoute>
              <GedCompras />
            </ProtectedRoute>
          }
        />

        <Route
          path="/GED_internos"
          element={
            <ProtectedRoute>
              <GedInternos />
            </ProtectedRoute>
          }
        />

        <Route
          path="/GED_externos"
          element={
            <ProtectedRoute>
              <GedExternos />
            </ProtectedRoute>
          }
        />

        {/* INICIO VITOR */}

        <Route
          path="/PesquisaCliente_lista"
          element={
            <ProtectedRoute>
              <PesquisaClienteLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/SatisfacaoClientePesquisa_lista"
          element={
            <ProtectedRoute>
              <SatisfacaoClientePesquisaLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/CadastroPesquisa_lista"
          element={
            <ProtectedRoute>
              <CadastroPesquisaLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/CadastroPesquisaItens_cadastro"
          element={
            <ProtectedRoute>
              <CadastroPesquisaItensCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/CategoriaAssistencia_lista"
          element={
            <ProtectedRoute>
              <CategoriaAssistenciaLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/AssistenciaTecnica_lista"
          element={
            <ProtectedRoute>
              <AssistenciaTecnicaLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/AssistenciaTecnica_cadastro"
          element={
            <ProtectedRoute>
              <AssistenciaTecnicaCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/GED_entregaobras"
          element={
            <ProtectedRoute>
              <GedEntregaObras />
            </ProtectedRoute>
          }
        />

        <Route
          path="/GED_maquinasequip"
          element={
            <ProtectedRoute>
              <GedMaquinasEquip />
            </ProtectedRoute>
          }
        />

        <Route
          path="/GED_obras"
          element={
            <ProtectedRoute>
              <GedObras />
            </ProtectedRoute>
          }
        />

        <Route
          path="/GED_comercial"
          element={
            <ProtectedRoute>
              <GedComercial />
            </ProtectedRoute>
          }
        />

        <Route
          path="/GED_financeiro"
          element={
            <ProtectedRoute>
              <GedFinanceiro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/GED_equipamentomedicao"
          element={
            <ProtectedRoute>
              <GedEquipamentoMedicoes />
            </ProtectedRoute>
          }
        />

        <Route
          path="/GED_projetos"
          element={
            <ProtectedRoute>
              <GedProjetos />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Principal_RH"
          element={
            <ProtectedRoute>
              <PrincipalRh />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Principal_Compras"
          element={
            <ProtectedRoute>
              <PrincipalCompras />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Principal_Obras"
          element={
            <ProtectedRoute>
              <PrincipalObras />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Principal_entregaobra"
          element={
            <ProtectedRoute>
              <PrincipalEntregaObras />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Principal_comercial"
          element={
            <ProtectedRoute>
              <PrincipalComercial />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Principal_controledocumentos"
          element={
            <ProtectedRoute>
              <PrincipalControleDocumentos />
            </ProtectedRoute>
          }
        />
        {/* Agente */}
        <Route
          path="/agenteIA"
          element={
            <ProtectedRoute>
              <ChatPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/IndicadoresServicosObras"
          element={
            <ProtectedRoute>
              <IndicadoresServicosObras />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Obras_documentos"
          element={
            <ProtectedRoute>
              <ObrasDocumentos />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Principal_gestaoepi"
          element={
            <ProtectedRoute>
              <PrincipalGestaoEPI />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Cadastro_epi"
          element={
            <ProtectedRoute>
              <CadastroEpiLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Controle_recebimento_epi"
          element={
            <ProtectedRoute>
              <ControleRecebimentoEpiLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Termo_epi"
          element={
            <ProtectedRoute>
              <TermoEpiLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Distribuicao_epi"
          element={
            <ProtectedRoute>
              <DistribuicaoEpiLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/CadastroCores_lista"
          element={
            <ProtectedRoute>
              <CadastroCoresLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/CadastroAprovadores_lista"
          element={
            <ProtectedRoute>
              <CadastroAprovadoresLista />
            </ProtectedRoute>
          }
        />

        <Route
          path="/ObrasConcretagem_cadastro"
          element={
            <ProtectedRoute>
              <ObrasConcretagemCadastro />
            </ProtectedRoute>
          }
        />

        <Route
          path="/ChecklistServicoLiberacao_lista"
          element={
            <ProtectedRoute>
              <ChecklistServicoLiberacaoLista />
            </ProtectedRoute>
          }
        />

        {/* FIM VITOR */}

        {/* LEGADO */}

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/old_login"
          element={
            <GuestRoute>
              <Login />
            </GuestRoute>
          }
        />

        <Route
          path="/old_configure"
          element={
            <GuestRoute>
              <ConfigureLogin />
            </GuestRoute>
          }
        />

        <Route
          path="/"
          index
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/old_Funcionarios_lista"
          element={
            <ProtectedRoute>
              <FuncionarioList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/old_Funcionarios_cadastro"
          element={
            <ProtectedRoute>
              <FuncionarioRegister />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Cargos_lista_old"
          element={
            <ProtectedRoute>
              <CargoList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Cargos_cadastro_old"
          element={
            <ProtectedRoute>
              <CargoRegister />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Acesso_negado"
          element={
            <ProtectedRoute>
              <AcessoNegado />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ControleServicos_lista"
          element={
            <ProtectedRoute>
              <ControleServicosLista />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ControleMateriais_lista"
          element={
            <ProtectedRoute>
              <ControleMateriaisLista />
            </ProtectedRoute>
          }
        />
        <Route
          path="/teste"
          element={
            <ProtectedRoute>
              <FuncionarioList />
            </ProtectedRoute>
          }
        />
        <Route
          path="*"
          element={
            <ProtectedRoute>
              <AcessoNegado />
            </ProtectedRoute>
          }
        />
      </Routes>
    </>
  );
}

export default Router;
